import { GREY_400, GREY_800, PURPLE_700, Text } from '@mnd-frontend/ui';
import styled from 'styled-components';
import ExternalLink from './ExternalLink';

const GuideSubtitle = styled.p`
  font-size: 0.75rem;
  line-height: 1.5rem;
  color: ${GREY_800};
  text-transform: uppercase;
  margin-bottom: 0;
`;

const PanelQuestions = styled.div`
  ul {
    padding-left: 0;
  }
  li {
    list-style: none;
    color: ${PURPLE_700};
    border-bottom: 1px solid ${GREY_400};
    font-size: 16px;
    line-height: 1.5;
    margin: 0;
    padding: 0.5rem 0;
    cursor: pointer;

    &:last-child {
      border-bottom: none;
    }
  }
`;

const PanelDescription = styled.div`
  margin: 0 0 1.5rem;
`;

const MainBody = ({
  content,
  onQuestionClick,
  onExternalLinkClick,
}: {
  content: {
    externalLinks?: { title: string; link: string }[];
    description?: string;
    guides: { questions: { title: string }[]; title: string }[];
  };
  onQuestionClick: (arg: { category: string; question: string }) => void;
  onExternalLinkClick: (str: string) => void;
}) => (
  <>
    {content.description && (
      <PanelDescription>
        <Text as="p" variant="body">
          {content.description}
        </Text>
      </PanelDescription>
    )}
    {!!content.guides.length && (
      <div>
        <Text as="h3" variant="headlineSmall">
          Guides
        </Text>
        {content.guides.map(guide => (
          <PanelQuestions key={guide.title}>
            <GuideSubtitle>{guide.title}</GuideSubtitle>
            <ul>
              {guide.questions.map(question => (
                <li
                  key={question.title}
                  onClick={() =>
                    onQuestionClick({ question: question.title, category: guide.title })
                  }
                  onKeyDown={e =>
                    e.key === 'Enter' &&
                    onQuestionClick({ question: question.title, category: guide.title })
                  }
                >
                  {question.title}
                </li>
              ))}
            </ul>
          </PanelQuestions>
        ))}
        {content.externalLinks && !!content.externalLinks.length && (
          <>
            <Text as="h3" variant="headlineSmall">
              Read more
            </Text>
            <PanelQuestions>
              <ul>
                {content.externalLinks.map(link => (
                  <li
                    key={link.title}
                    onClick={() => {
                      onExternalLinkClick(link.title);
                    }}
                  >
                    <ExternalLink link={link.link} text={link.title} />
                  </li>
                ))}
              </ul>
            </PanelQuestions>
          </>
        )}
      </div>
    )}
  </>
);

export default MainBody;
